import { Pipe, PipeTransform } from '@angular/core';
import { displayUserStatus } from 'app/core/options/user-status.opts';

@Pipe({
  name: 'userStatus',
})
export class UserStatusPipe implements PipeTransform {
  transform = displayUserStatus
}
